import { createSlice } from "@reduxjs/toolkit";

export interface IAllCsvDownloadsState {
  isModalOpened: boolean;
}

const INITIAL_STATE: IAllCsvDownloadsState = {
  isModalOpened: false,
};

export const allCsvDownloadsSlice = createSlice({
  name: "allCsvDownloads",
  initialState: INITIAL_STATE,
  reducers: {
    toggleModal(state, action) {
      state.isModalOpened = action.payload;
    },
  },
});

export default allCsvDownloadsSlice.reducer;
